// Auto-generated normalizer for table: CuestionariosRespuestas
export function cuestionariosRespuestasNormalize(row) {
  return {
    idRespuesta: row.idRespuesta ?? row.IdRespuesta ?? row['IdRespuesta'] ?? 0,
    idIntento: row.idIntento ?? row.IdIntento ?? row['IdIntento'] ?? 0,
    idPregunta: row.idPregunta ?? row.IdPregunta ?? row['IdPregunta'] ?? 0,
    correcta: row.correcta ?? row.Correcta ?? row['Correcta'] ?? '',
    explicacion: row.explicacion ?? row.Explicacion ?? row['Explicacion'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
